import { environment } from '../../../environments/environment';

export const ApiEndpoints = {
  authentication: {
    login: environment.apiUrl + '/client/authentication/login',
    sendVerificationCode: environment.apiUrl + '/client/Accounts/forget',
    validate: environment.apiUrl + '/client/Accounts/validate',
    reset: environment.apiUrl + '/client/Accounts/reset',
    logout: environment.apiUrl + '/client/Accounts/me/sign-out',
  },

  configurations: {
    GetByName: environment.apiUrl + '/client/configurations',
    GetClientData: environment.apiUrl + '/client/Accounts/clients',
    timeZone: environment.apiUrl + '/core/google-map/timezone',
    timeZoneData: environment.apiUrl + '/core/timezone',
    serverTimeZone: environment.apiUrl + '/client/timezone/server-timezone',
  },

  dashboards: {
    GetDashboard: environment.apiUrl + '/client/dashboard',
  },

  profile: {
    updateProfile: environment.apiUrl + '/client/Accounts',
    updatePassword: environment.apiUrl + '/client/Accounts/me/change-password',
    updatePhoto: environment.apiUrl + '/client/file/uploadFile',
    downloadPhoto: environment.apiUrl + '/client/file/downloadFile',
  },

  places: {
    getGridData: environment.apiUrl + '/client/places',
    downloadExcelReport: environment.apiUrl + '/client/places/excel-report',
  },

  reports: {
    getNoShowGridData: environment.apiUrl + '/client/no-show',
    downloadNoShowExcelReport:
      environment.apiUrl + '/client/no-show/excel-report',
    noShowStudents: environment.apiUrl + '/client/no-show/students',
    getStudentsProfile: environment.apiUrl + '/client/no-show/students',
    getHistoricalReportGrid:
      environment.apiUrl + '/client/historical/rides-finder',
    getHistoricalReportExcel:
      environment.apiUrl + '/client/historical/rides-finder/excel',
    getRideSummarySheet: environment.apiUrl + '/client/rides',
    getDriverInfo: environment.apiUrl + '/client/rides/',
    getWayPoint: environment.apiUrl + '/client/rides/',
    getWayPointActivityLog: environment.apiUrl + '/client/rides/',
    getConsecutiveReports:
      environment.apiUrl + '/client/no-show/consecutive-no-show-report',
    exportConsecutiveReports:
      environment.apiUrl + '/client/no-show/consecutive-no-show-report/excel',
    getPlaces: environment.apiUrl + '/client/historical/rides-finder/places',
    getBluePrints:
      environment.apiUrl + '/client/historical/rides-finder/blueprints',
    getStudents:
      environment.apiUrl + '/client/historical/rides-finder/passengers',
    studentDetails: environment.apiUrl + '/client/historical/rides-finder',
  },

  routes: {
    getGridData: environment.apiUrl + '/client/route',
    downloadExcelReport: environment.apiUrl + '/client/route/excel-report',
    getStudents: environment.apiUrl + '/client/route/students',
    getBluePrint: environment.apiUrl + '/client/route',
    getContainers: environment.apiUrl + '/client/route/invoice-containers',
    getBluePrints: environment.apiUrl + '/client/route/ride-blueprints',
    getPlaces: environment.apiUrl + '/client/route/ride-blueprints/places',
    getSummaryData: environment.apiUrl + '/client/route/blueprint-statistics ',
  },

  invoices: {
    getInvoicesGridData: environment.apiUrl + '/client/invoice',
    downloadInvoicesExcelReport: environment.apiUrl + '/client/invoice/excel',
    getInvoicesViewPdfData: environment.apiUrl + '/client/invoice/',
    getInvoiceDetailsGridData: environment.apiUrl + '/client/invoice/',
    getInvoicePdfData: environment.apiUrl + '/client/invoice/',
    downloadInvoicesExcelDetailsReport: environment.apiUrl + '/client/invoice/',
  },

  passengers: {
    getGuardianGridData: environment.apiUrl + '/client/guardian',
    guardianExcelReport: environment.apiUrl + '/client/guardian/excel-report',
    guardianStudents: environment.apiUrl + '/client/guardian/students',
    deleteGuardian: environment.apiUrl + '/client/guardian/',
    blockGuardian: environment.apiUrl + '/client/guardian',
    archiveGuardian: environment.apiUrl + '/client/guardian',
    existingGuardian: environment.apiUrl + '/client/guardian',
    newGuardian: environment.apiUrl + '/client/guardian',
    editGuardianData: environment.apiUrl + '/client/guardian',
    resetPassword: environment.apiUrl + '/client/guardian/reset-password',
    getStudents: environment.apiUrl + '/client/guardian/students ',
    getAddresses: environment.apiUrl + '/client/guardian/address ',
    addPlace: environment.apiUrl + '/client/guardian',
    deletePlace: environment.apiUrl + '/client/guardian',
    unlinkStudent: environment.apiUrl + '/client/guardian/students',
    getLocationData: environment.apiUrl + '/client/guardian/location',
    updateGuardianData: environment.apiUrl + '/client/guardian',
    getGuardianDropdown: environment.apiUrl + '/client/guardian/dropdown',

    /*** student api  */
    getStudentGridData: environment.apiUrl + '/client/student',
    studentsExcelReport: environment.apiUrl + '/client/student/excel',
    getStudentPlaces: environment.apiUrl + '/client/student/place',
    bulkStudentImport:
      environment.apiUrl + '/client/student/import/bulkStudents',
    getStudentLocationData: environment.apiUrl + '/client/student/location',
    downloadExcelFile: environment.apiUrl + '/client/file/download-excel',
    placesCalendar: environment.apiUrl + '/client/places',
    addNewStudent: environment.apiUrl + '/client/student/new',
    getStudentGrades: environment.apiUrl + '/client/student/student-grades',
    getStudentSpecialEdd: environment.apiUrl + '/client/student/special-ed',
    getStudentPopulationTypes:
      environment.apiUrl + '/client/student/population-types',
    checkIfMobileEmailExists:
      environment.apiUrl + '/client/student/check-exists-mobile-number',
    getStudentMonitors: environment.apiUrl + '/client/student/assistants',
    getStudentNeeds: environment.apiUrl + '/client/student/ride-needs',
    editStudent: environment.apiUrl + '/client/student',

    //edit APIS

    //student
    getStudentFullData: environment.apiUrl + '/client/student',

    //guardian
    getStudentGuardians: environment.apiUrl + '/client/student',
    getStudentGuardianById: environment.apiUrl + '/client/student',
    editGuardianGridDate: environment.apiUrl + '/client/student',

    // emergency
    getStudentContacts: environment.apiUrl + '/client/student',
    getStudentContactById: environment.apiUrl + '/client/student',
    addStudentContacts: environment.apiUrl + '/client/contact',
    deleteContacts: environment.apiUrl + '/client/contact',
    editContacts: environment.apiUrl + '/client/contact',

    //address
    getStudentAddresses: environment.apiUrl + '/client/student',
    addStudentAddresses: environment.apiUrl + '/client/student',
    editStudentAddresses: environment.apiUrl + '/client/student',
    deleteStudentAddresses: environment.apiUrl + '/client/student',
    getStudentPlace: environment.apiUrl + '/client/student/places',

    //places
    addStudentPlaces: environment.apiUrl + '/client/student',
    editStudentPlaces: environment.apiUrl + '/client/student',
    deleteStudentPlaces: environment.apiUrl + '/client/student',

    //transportation schedule
    getStudentTransportationSchedule: environment.apiUrl + '/client/student',
    addStudentTransportationSchedule: environment.apiUrl + '/client/student',
    editStudentTransportationSchedule: environment.apiUrl + '/client/student',
    deleteStudentTransportationSchedule: environment.apiUrl + '/client/student',

    //serviceCancellation
    getStudentServiceCancellation:
      environment.apiUrl + '/client/service-cancellation/student',
    addStudentServiceCancellation:
      environment.apiUrl + '/client/service-cancellation/create',
    editStudentServiceCancellation:
      environment.apiUrl + '/client/service-cancellation',
    getStudentServiceCancellationById:
      environment.apiUrl + '/client/service-cancellation',
    deleteStudentServiceCancellation:
      environment.apiUrl + '/client/service-cancellation',

    //Instruction
    getStudentInstruction: environment.apiUrl + '/client/student',
    addStudentInstruction: environment.apiUrl + '/client/student',
    editStudentInstruction: environment.apiUrl + '/client/student',
    deleteStudentInstruction: environment.apiUrl + '/client/student',
    checkInstructionExists: environment.apiUrl + '/client/student',

    //Attachments
    getStudentAttachments: environment.apiUrl + '/client/student',
    addStudentAttachments: environment.apiUrl + '/client/student',
    editStudentAttachments: environment.apiUrl + '/client/student',
    deleteStudentAttachments: environment.apiUrl + '/client/student',
    deleteAttachment: environment.apiUrl + '/client/student/',
    editAttachment: environment.apiUrl + '/client/student/',
    downloadAttachment: environment.apiUrl + '/client/student/download-file',
    removePhoto: environment.apiUrl + '/client/student/remove-photo',
  },
  about: {
    getVersionSettings: environment.apiUrl + '/client/About/propertyName',
  }
};
